import { Accordion, Description, Heading } from '@heroui/react';

const FAQS = [
  {
    id: 'o-que-e',
    q: 'O Link Park substitui o grupo de WhatsApp da garagem?',
    a: 'Sim, nessa parte. Pedido, aprovação, horário e histórico ficam no app. O grupo pode continuar para o restante da vida do prédio.',
  },
  {
    id: 'emprestimo',
    q: 'Qual a diferença entre empréstimo e aluguel?',
    a: 'O dono da vaga escolhe. Empréstimo é cortesia entre vizinhos. Aluguel é uso combinado com contraprestação. Os dois passam pela mesma aprovação.',
  },
  {
    id: 'entrada',
    q: 'Como o morador entra no condomínio?',
    a: 'Cria a conta e pede associação ao gestor. O síndico vincula a pessoa ao apartamento e às vagas correspondentes.',
  },
  {
    id: 'app-loja',
    q: 'Precisa baixar na App Store ou Google Play?',
    a: 'Não. É um PWA: abre no navegador e pode ser instalado na tela inicial do celular, inclusive no iPhone.',
  },
  {
    id: 'varios',
    q: 'Funciona em mais de um condomínio?',
    a: 'Sim. A mesma conta troca de condomínio no menu. Gestores também administram vários empreendimentos.',
  },
] as const;

export function LandingFaq() {
  return (
    <section id="faq" className="scroll-mt-24 border-t border-separator">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:py-20">
        <div className="space-y-3">
          <Heading level={2} className="text-3xl font-bold tracking-tight">
            Perguntas frequentes
          </Heading>
          <Description>O essencial para síndico e morador antes de criar a conta.</Description>
        </div>

        <Accordion>
          {FAQS.map((item) => (
            <Accordion.Item key={item.id} id={item.id}>
              <Accordion.Heading>
                <Accordion.Trigger>
                  <span className="text-left text-sm font-semibold sm:text-base">{item.q}</span>
                  <Accordion.Indicator />
                </Accordion.Trigger>
              </Accordion.Heading>
              <Accordion.Panel>
                <Accordion.Body>
                  <Description className="pb-2">{item.a}</Description>
                </Accordion.Body>
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
